import { useNavigate, useParams } from "react-router-dom";
import { verifyImpersonateToken } from "../api";
import { useDispatch } from "react-redux";
import {
  setImpersonate,
  setIsAuthenticated,
  setUserDetails,
} from "../redux/slices/userSlice";
import { useCallback, useEffect } from "react";
import Loader from "../component/Loader";

const ImpersonateRedirection = () => {
  const { token } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const verifyToken = useCallback(async () => {
    try {
      const res = await verifyImpersonateToken({ body: { token } });
      const { accessToken, refreshToken, user } = res.data.data;
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("login", "true");
      // localStorage.setItem("activeUser", JSON.stringify(user.allowAccessToMap));
      dispatch(setUserDetails(user));
      dispatch(setImpersonate(true));
      dispatch(setIsAuthenticated(true));
      navigate("/dashboard");
    } catch (err) {
      navigate("/sign-in");
    }
  }, []);

  useEffect(() => {
    verifyToken();
  }, []);

  return <Loader showLoader={true} />;
};

export default ImpersonateRedirection;
